import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { AppStoreBadge, GooglePlayBadge } from "@/components/AppBadges";
import heroImage from "@/assets/hero-dashboard-new.png";
import { useLocale } from "@/i18n/detect";
import { useExtra } from "@/i18n/extra";

const Hero = () => {
  const { ui } = useLocale();
  const extra = useExtra();
  const t = ui.hero;

  return (
    <section className="relative overflow-hidden bg-gradient-hero">
      <div className="absolute inset-0 -z-10 opacity-60">
        <div className="absolute -top-24 left-1/2 h-96 w-[60rem] -translate-x-1/2 rounded-full bg-primary/20 blur-3xl" />
      </div>
      <div className="container py-20 md:py-28">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-1.5 text-xs font-semibold text-muted-foreground shadow-soft">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            {t.badge}
          </span>
          <h1 className="mt-6 font-display text-5xl font-extrabold leading-[1.05] tracking-tight text-secondary md:text-6xl lg:text-7xl">
            {t.titleStart}
            <span className="bg-gradient-primary bg-clip-text text-transparent">{t.titleHighlight}</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground md:text-xl">
            {t.subtitle}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button asChild variant="hero" size="xl" className="group">
              <a href="https://api.freecrm.com/register/?lang=en" target="_blank" rel="noopener noreferrer">
                {t.cta}
                <ArrowRight className="transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
          </div>
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            {t.pills.map((p) => (
              <li key={p} className="flex items-center gap-1.5">
                <Check className="h-4 w-4 text-primary" />
                {p}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-3">
            <p className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
              {extra.appBadges.takeWithYou}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <AppStoreBadge />
              <GooglePlayBadge />
            </div>
          </div>

        </div>

        <div className="mt-16 md:mt-20">
          <div className="relative mx-auto max-w-6xl">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-primary opacity-20 blur-2xl" />
            <img
              src={heroImage}
              alt={t.heroAlt}
              width={1920}
              height={1394}
              fetchPriority="high"
              decoding="async"
              className="relative w-full rounded-2xl border border-border bg-card shadow-elegant"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
